import { clientSpending, useFirmClient } from '../../../FirmClient';
import { useClientContext } from '../../../ClientContext';
import { MonetaryAmountWidget } from '../Widget';
import { UseAnnualSpendingWidgetArgs, useAnnualSpendingWidget } from './hooks';
import { recurringMonetaryAmountConverter } from '../../../util';
import { RecurringFrequency } from '../../../generated/graphql';
import { Link } from '@remix-run/react';

interface AnnualSpendingWidgetProps extends UseAnnualSpendingWidgetArgs {
  onClick?: () => void;
  linkTo?: string;
}

export function AnnualSpendingWidget(props: AnnualSpendingWidgetProps) {
  const { isLoading, tCommon } = useAnnualSpendingWidget(props);
  const { firmID, clientID } = useClientContext();
  const { firmClient } = useFirmClient({ firmID, firmClientID: clientID });

  const Widget = () => {
    return (
      <MonetaryAmountWidget
        isLoading={isLoading}
        monetaryAmount={
          recurringMonetaryAmountConverter(
            clientSpending(firmClient).recurringMonetaryAmount,
            RecurringFrequency.Annually
          ).amount
        }
        title={tCommon('annual-spending-button-title')}
        onClick={props.onClick}
        withChevron={!!props.linkTo || !!props.onClick}
      />
    );
  };

  return props.linkTo ? (
    <Link to={props.linkTo || ''} state={{ viewIndex: 1 }}>
      <Widget />
    </Link>
  ) : (
    <Widget />
  );
}
